import { render } from "./AppSidebar.vue?vue&type=template&id=6999ca81&scoped=true&ts=true&lang=pug"
import script from "./AppSidebar.vue?vue&type=script&lang=ts&setup=true"
export * from "./AppSidebar.vue?vue&type=script&lang=ts&setup=true"

import "./AppSidebar.vue?vue&type=style&index=0&id=6999ca81&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6999ca81"]])

export default __exports__